const { useEffect } = require('react');
const { useField } = require('react-final-form');

const useLoadingWizard = (isLoading) => {
  const {
    input: { onChange }
  } = useField('isLoading');

  useEffect(() => {
    onChange(isLoading);
  }, [isLoading, onChange]);
};

export default useLoadingWizard;
